{
  "liveStreams": {
    "actions": {
      "restartAll": "Restart all",
      "restartBody": "Are you sure you want to restart all live streams?",
      "restartBodyNote": "(this can cause some minor downtime)",
      "restartTitle": "Restart"
    },
    "emptyState": {
      "description": "No live streams are currently running.",
      "title": "No active streams"
    },
    "filters": {
      "lowSpeed": "Low speed",
      "noPing": "No ping",
      "recentRestarts": "Recent restarts",
      "refresh": "Refresh",
      "search": "Search",
      "status": "Status"
    },
    "page": {
      "breadcrumb": "Admin - Live streams",
      "title": "Admin - Live streams"
    },
    "restartAllPartial": "{{failed}} of {{attempted}} streams could not be restarted",
    "stats": {
      "lowSpeed": "Low speed",
      "noPing": "No ping",
      "recentRestart": "Recent restart",
      "total": "Total: {{count}}"
    }
  },
  "users": {
    "actions": {
      "actionsButton": "Actions",
      "activate": "Activate",
      "activateBody": "Are you sure you want to activate this user?",
      "activateTitle": "Activate user",
      "delete": "Delete user",
      "deleteBody": "Are you sure you want to delete this user?",
      "deleteTitle": "Delete this user?",
      "impersonate": "Impersonate",
      "suspend": "Suspend",
      "suspendBody": "Are you sure you want to suspend the user?",
      "suspendTitle": "Suspend user",
      "toBeDeleted": "To be deleted",
      "toBeDeletedBody": "Are you sure you want to mark the user to be deleted?",
      "toBeDeletedTitle": "Mark to be deleted"
    },
    "buttons": {
      "refresh": "Refresh"
    },
    "columns": {
      "actions": "Actions",
      "country": "Country",
      "id": "ID",
      "ips": "IPs",
      "lastSeen": "Last seen",
      "liveStreams": "Live streams",
      "mediaSize": "Media size",
      "nameEmail": "Name / Email",
      "status": "Status",
      "cleanupSuggestions": "Cleanup suggestions"
    },
    "emptyState": {
      "description": "No users match your current filters.",
      "title": "No users found"
    },
    "filters": {
      "activeSubscription": "Active subscription",
      "needsMediaDelete": "Needs media delete",
      "online": "Online",
      "overdue": "Overdue",
      "search": "Search",
      "toBeDeleted": "To be deleted"
    },
    "ips": {
      "latest": "Latest: {{ip}}",
      "others": "Others",
      "register": "Register: {{ip}}"
    },
    "media": {
      "audio": "Audio: {{size}} GB",
      "visual": "Visual media: {{size}} GB"
    },
    "notifications": {},
    "page": {
      "breadcrumb": "Admin - Users",
      "title": "Admin - Users"
    },
    "toBeDeletedWaiting_one": "Waiting {{count}} day",
    "toBeDeletedWaiting_other": "Waiting {{count}} days",
    "cleanup": {
      "mediaGraceExpired": "Media grace expired"
    }
  },
  "cleanup": {
    "title": "Stream media cleanup",
    "loadError": "Unable to load streams.",
    "noSubscription": "No subscription",
    "empty": "No streams found.",
    "delete": "Delete media",
    "operationError": "Unable to load cleanup progress.",
    "requestError": "Cleanup could not be confirmed. Refresh progress or try again.",
    "mediaItems": "media items",
    "completed": "Media cleanup completed.",
    "progress": "Cleanup progress",
    "pendingSteps": "pending steps",
    "retry": "Retry",
    "confirmPrefix": "Delete media for"
  },
  "abuse": {
    "blockedTitle": "Blocked registrations",
    "incidentsTitle": "Trial reuse reports",
    "blockedDescription": "Signups rejected by the registration rules. Shared networks and devices can cause false positives.",
    "incidentsDescription": "Suspected identity reuse across accounts. These reports do not block streaming and are not proof of abuse.",
    "blockedEmpty": "No blocked registrations",
    "incidentsEmpty": "No trial reuse reports",
    "emptyDescription": "New reports will appear here when a rule finds a match.",
    "deletedAccount": "Deleted account",
    "noAccount": "No related account",
    "all": "All reasons",
    "total": "{{count}} reports",
    "email": "Email",
    "reason": "Reason",
    "ip": "IP address",
    "device": "Device",
    "relatedAccount": "Related account",
    "account": "Trial account",
    "kind": "Matched identity",
    "sourceAccount": "Previous account",
    "date": "Recorded",
    "reasons": {
      "duplicateEmail": "Duplicate email",
      "disposableEmail": "Disposable email",
      "unresolvableEmailDomain": "Domain has no web address",
      "duplicateIp": "Duplicate IP",
      "duplicateFingerprint": "Duplicate device"
    },
    "kinds": {
      "streamKey": "Stream key",
      "deviceFingerprint": "Device fingerprint"
    }
  }
}
